import React from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import AccessTime from "@mui/icons-material/AccessTime";
import SportsEsports from "@mui/icons-material/SportsEsports";
import BubbleChart from "@mui/icons-material/BubbleChart";
import Person from "@mui/icons-material/Person";
import LocalMall from "@mui/icons-material/LocalMall";
import AttachMoney from "@mui/icons-material/AttachMoney";
import WorkspacePremium from "@mui/icons-material/WorkspacePremium";
import Fingerprint from "@mui/icons-material/Fingerprint";
import Female from "@mui/icons-material/Female";
import VerifiedUser from "@mui/icons-material/VerifiedUser";

const useStyles = makeStyles((theme) => ({
    matchmakingOptionRow: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '94%',
        marginBottom: 0,
        // padding: '0.72rem 0.78rem',
        padding: '0.72rem 0.78rem 0.65rem 0.78rem',
        borderRadius: '10px',
        backgroundColor: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.06)',
    },
    rowText: { 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        width: '100%',
        gap: '0.75rem',
    },
    settingTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.35rem',
        flex: 1,
        minWidth: 0,
    },
    settingIcon: {
        color: '#E8A33D',
        fontSize: '0.9rem',
        [theme.breakpoints.up("xl")]: {
            fontSize: '1.05rem',
        },
    },
    matchmakingOptionTitle: {
        color: '#ffffff',
        fontSize: '0.85rem !important',
        lineHeight: 1.2,
        letterSpacing: '0.15px',
        fontWeight: 500,
        [theme.breakpoints.up("xl")]: {
            fontSize: '0.85rem !important',
        },
    },
    containerRowActions: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
    },
    toggle: {
        position: 'relative',
        width: '2.35rem',
        height: '1.25rem',
        borderRadius: '20px',
        backgroundColor: '#393939',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&.active': {
            backgroundColor: '#E8A33D',
            boxShadow: '0 4px 15px rgba(232, 163, 61, 0.3)',
        },
        [theme.breakpoints.up("xl")]: {
            width: '2.8rem',
            height: '1.5rem',
            borderRadius: '22px',
        },
    },
    toggleButton: {
        position: 'absolute',
        width: '0.95rem',
        height: '0.95rem',
        top: '0.15rem',
        left: '0.15rem',
        borderRadius: '50%',
        backgroundColor: '#E8A33D',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: 'translateX(0)',
        '&:hover': {
            backgroundColor: 'rgba(232, 163, 61, 0.9)',
        },
        '&.active': {
            backgroundColor: '#393939',
            transform: 'translateX(1.08rem)',
            '&:hover': {
                backgroundColor: 'rgba(39, 39, 39, 0.9)',
            },
        },
        [theme.breakpoints.up("xl")]: {
            width: '1.15rem',
            height: '1.15rem',
            top: '0.18rem',
            left: '0.18rem',
            '&.active': {
                backgroundColor: '#393939',
                transform: 'translateX(1.3rem)',
                '&:hover': {
                    backgroundColor: 'rgba(39, 39, 39, 0.9)',
                },
            },
        },
    },
    containerNumberSlider: {
        marginTop: '0.55rem',
        opacity: 0,
        transform: 'translateY(-10px)',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        pointerEvents: 'none',
        maxHeight: 0,
        overflow: 'hidden',
        marginBottom: 0,
    },
    containerNumberSliderVisible: {
        opacity: 1,
        transform: 'translateY(0)',
        pointerEvents: 'auto',
        maxHeight: '4rem',
        overflow: 'visible',
        marginBottom: '0.7rem',
    },
    sliderContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '0.75rem',
        marginTop: '0.3rem',
    },
    sliderInput: {
        width: '5rem',
        [theme.breakpoints.up("xl")]: {
            width: '6.5rem',
        },
        '& .MuiInputLabel-root': {
          [theme.breakpoints.up("xl")]: {
            fontSize: '1.25rem',
          },
        },
        '& .MuiOutlinedInput-root': {
          color: '#ffffff',
          fontSize: '0.72rem',
          backgroundColor: '#393939',
          borderRadius: '0.5rem',
          boxShadow:'inset 0 2px 4px rgba(0, 0, 0, 0.3), inset 0 1px 2px rgba(0, 0, 0, 0.2)',
          [theme.breakpoints.up("xl")]: {
            fontSize: '0.82rem',
            borderRadius: '0.6rem',
          },
          '& fieldset': {
            borderColor: 'rgba(232, 163, 61, 0.2)',
            borderWidth: '1px',
            borderRadius: '0.5rem',
            [theme.breakpoints.up("xl")]: {
              borderRadius: '0.6rem',
            },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(232, 163, 61, 0.4)',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#E8A33D',
            borderWidth: '1px',
          },
        },
        '& .MuiOutlinedInput-input': {
          textAlign: 'left',
          padding: '0.65rem 0.6rem',
          '&::placeholder': {
            color: 'rgba(255, 255, 255, 0.5)',
          },
          [theme.breakpoints.up("xl")]: {
            padding: '0.85rem 0.8rem',
          },
        },
    },
    customSlider: {
        maxWidth: '17rem',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.up("xl")]: {
            maxWidth: '21.5rem',
        },
        '& .MuiSlider-root': {
            color: '#E8A33D',
            height: '5px',
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.up("xl")]: {
                height: '6px',
            },
        },
        '& .MuiSlider-track': {
            backgroundColor: '#E8A33D',
            border: 'none',
            height: '5px',
            borderRadius: '3px',
            [theme.breakpoints.up("xl")]: {
                height: '6px',
            },
        },
        '& .MuiSlider-rail': {
            backgroundColor: '#393939',
            height: '5px',
            borderRadius: '3px',
            [theme.breakpoints.up("xl")]: {
                height: '6px',
            },
        },
        '& .MuiSlider-thumb': {
            backgroundColor: '#E8A33D',
            border: 'none',
            width: '1rem',
            height: '1rem',
            marginTop: '-1px',
            marginLeft: '-4px',
            boxShadow: 'none !important',
            [theme.breakpoints.up("xl")]: {
                width: '1.2rem',
                height: '1.2rem',
                marginTop: '-2px',
                marginLeft: '-6px',
            },
            '&:hover': {
                boxShadow: 'none !important',
            },
            '&.Mui-focusVisible': {
                boxShadow: 'none !important',
            },
            '&.Mui-active': {
                boxShadow: 'none !important',
            },
            '&.Mui-dragging': {
                boxShadow: 'none !important',
            },
        },
    },
    sliderInputContainer: {
        display: 'flex',
        alignItems: 'center',
    },
}));

const iconMap = {
    AccessTime,
    SportsEsports,
    BubbleChart,
    Person,
    LocalMall,
    AttachMoney,
    WorkspacePremium,
    Fingerprint,
    Female,
    VerifiedUser,
};

export default function SettingOptionRow({ 
    setting, 
    onToggleChange, 
    onSliderChange, 
    showSlider = false,
    disabled = false
}) {
    const classes = useStyles();

    const handleToggleClick = () => {
        if (disabled) return;
        onToggleChange(setting.id, !setting.toggleState);
    };

    const handleSliderChange = (event, newValue) => {
        onSliderChange(setting.id, newValue);
    };

    const handleSliderInputChange = (event) => {
        const value = parseInt(event.target.value) || 0;
        onSliderChange(setting.id, value);
    };

    const IconComponent = iconMap[setting.icon];

    return (
        <div
            className={classes.matchmakingOptionRow}
            style={setting.toggleState
                ? {
                    backgroundColor: 'rgba(232, 163, 61, 0.08)',
                    border: '1px solid rgba(232, 163, 61, 0.18)',
                }
                : undefined}
        >
            <div className={classes.rowText}>
                <div className={classes.settingTitleContainer}>
                    {IconComponent && <IconComponent className={classes.settingIcon} />}
                    <Typography className={classes.matchmakingOptionTitle}>
                        {setting.title}
                    </Typography>
                </div>
                <div className={classes.containerRowActions}>
                    <div 
                        className={`${classes.toggle} ${setting.toggleState ? 'active' : ''}`}
                        onClick={handleToggleClick}
                    >
                        <div className={`${classes.toggleButton} ${setting.toggleState ? 'active' : ''}`}/>
                    </div>
                </div>
            </div>
            {setting.description && (
                <Typography
                    sx={{
                        color: "rgba(255,255,255,0.52)",
                        fontSize: "0.68rem",
                        lineHeight: 1.3,
                        mt: 0.55,
                    }}
                >
                    {setting.description}
                </Typography>
            )}
            
            {showSlider && setting.sliderConfig && (
                <div className={`${classes.containerNumberSlider} ${setting.toggleState ? classes.containerNumberSliderVisible : ''}`}>
                    <div className={classes.sliderContainer}>
                        <div className={classes.customSlider}>
                            <Slider
                                value={setting.sliderValue || 0}
                                onChange={handleSliderChange}
                                min={setting.sliderConfig.min || 0}
                                max={setting.sliderConfig.max || 100}
                                step={setting.sliderConfig.step || 1}
                                aria-labelledby={`${setting.id}-slider`}
                                disabled={disabled}
                            />
                        </div>
                        <div className={classes.sliderInputContainer}>
                            <TextField
                                id={`${setting.id}-input`}
                                className={classes.sliderInput}
                                value={setting.sliderValue || 0}
                                onChange={handleSliderInputChange}
                                type="number"
                                variant="outlined"
                                label={setting.sliderConfig.label || "value"}
                                disabled={disabled}
                                inputProps={{
                                    min: setting.sliderConfig.min || 0,
                                    max: setting.sliderConfig.max || 100,
                                    step: setting.sliderConfig.step || 1
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}